module.exports = __webpack_public_path__ + "static/img/function-box-img4.7a5b404.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedPortal/function-box-img4.jpg
// module id = rxfw
// module chunks = 0